export const MOBILE_STORAGE_KEY = `@store_mobile`;

export type TGpsDataSource = "Iox" | "Web";
export interface IGpsData {
    latitude: GeolocationCoordinates["latitude"];
    longitude: GeolocationCoordinates["longitude"];
    dateTime: string;
    speed: number | null;   // speed in km/h
    source: TGpsDataSource;
}

export interface ISyncInterval {
    fromDate?: string;
    extendedFromDate?: string;
    toDate?: string;
}

export interface IMobileStore {
    pageState: IMobilePageState;
    charging?: boolean;
    batteryLevel?: number;
    background?: boolean;
    online?: NetworkStates;
    deviceCommunicating?: boolean;
    lastDeviceCommunicationDateTime?: string;
    gpsConnected?: boolean;
    lastPosition?: GeolocationPosition;
    embed?: boolean;
    eldMalfunction?: boolean;
    eldDiagnostic?: boolean;
    diagnosticViewed?: boolean;
    newUpcomingViolation?: boolean;
    driverActionNecessary?: IDriverActionNecessary;
    language?: string;
    ioxAttached?: boolean;
    gpsData?: IGpsData;
    lastViewedLog?: IViewedLog;
    device?: IIdEntity | null;
    setDevice?: Function;
    newMessage?: boolean;
    previousPage?: string;
    currentPage?: string;
    loginRequired: ILoginRequiredState;
    pcLimitWarningMessage?: string;
    pendoResourceCenterAvailable: boolean;
    tripCategorizationSyncInterval?: ISyncInterval;
    lastKnownSpeed?: ILastKnownSpeed;
    iam: IIdDictionary<boolean>;
    iamSessionInvalidated: IIdDictionary<boolean>;
    dvirDurationStartTime?: Date;
}

export enum NetworkStates {
    ONLINE = "ONLINE",
    CLIENT_OFFLINE = "CLIENT_OFFLINE",
    SERVER_OFFLINE = "SERVER_OFFLINE",
    OFFLINE = "OFFLINE"
}

export enum MobileActionTypes {
    SET_PAGESTATE = "SET_PAGESTATE",
    SET_CHARGING = "SET_CHARGING",
    SET_BATTERYLEVEL = "SET_BATTERYLEVEL",
    SET_BACKGROUND = "SET_BACKGROUND",
    SET_ONLINE = "SET_ONLINE",
    SET_DEVICE_COMMUNICATING = "SET_DEVICE_COMMUNICATING",
    SET_LAST_DEVICE_COMMUNICATION_DATETIME = "SET_LAST_DEVICE_COMMUNICATION_DATETIME",
    SET_GPS = "SET_GPS",
    SET_EMBED = "SET_EMBED",
    SET_ELDMALFUNCTION = "SET_ELDMALFUNCTION",
    SET_NEWUPCOMINGVIOLATION = "SET_NEWUPCOMINGVIOLATION",
    SET_ELDDIAGNOSTIC = "SET_ELDDIAGNOSTIC",
    SET_DIAGNOSTICVIEWED = "SET_DIAGNOSTICVIEWED",
    SET_LANGUAGE = "SET_LANGUAGE",
    SET_DRIVERACTIONNECESSARY = "SET_DRIVERACTIONNECESSARY",
    SET_IOX_ATTACHED = "SET_IOX_ATTACHED",
    SET_GPS_DATA = "SET_GPS_DATA",
    SET_LAST_VIEWED_LOG = "SET_LAST_VIEWED_LOG",
    SET_NEW_MESSAGE = "SET_NEW_MESSAGE",
    SET_PREVIOUS_PAGE = "SET_PREVIOUS_PAGE",
    SET_LOGIN_REQUIRED = "SET_LOGIN_REQUIRED",
    SET_PCLIMIT_WARNING = "SET_PCLIMIT_WARNING",
    SET_PAGE_LOADED = "SET_PAGE_LOADED",
    SET_PENDO_RESOURCE_CENTER_AVAILABLE = "SET_PENDO_RESOURCE_CENTER_AVAILABLE",
    SET_TRIP_CATEGORIZATION_SYNC_INTERVAL = "SET_TRIP_CATEGORIZATION_SYNC_INTERVAL",
    SET_LAST_KNOWN_SPEED = "SET_LAST_KNOWN_SPEED",
    SET_IAM_USER_REFRESH_STATE = "SET_IAM_USER_REFRESH_STATE",
    SET_IAM_SESSION_INVALIDATED_STATE = "SET_IAM_SESSION_INVALIDATED_STATE",
    SET_DVIR_DURATION_START_TIME = "SET_DVIR_DURATION_START_TIME"
}

export enum PageLevel {
    ZERO = 0, // Login page where nothing on top or menu
    ONE = 1, // Normal view
    TWO = 2, // Allow back arrow
    FORCE_LOGOUT = 3, // 3,4,5 is where it goes if "X" is hit
    RETURN_DASHBOARD = 4,
    RETURN_ASSETS = 5,
    ASSET_SPECIFIC_PAGE = 6,
    SUBMENU_WITH_BACK_BUTTON = 7
}

export interface IMobilePageState {
    title?: string;
    activeSection?: string;
    activeView?: string;
    pageLevel: PageLevel;
    isLocked?: boolean;
    name?: string;
}

export interface IBackground {
    isBackground?: boolean;
    code: any;
}

export interface IGps {
    position?: GeolocationPosition;
    isConnected?: boolean;
}

export interface IDriverActionNecessary {
    isNecessary: boolean;
    actionType: DriverActionTypes;
}

export interface IViewedLog {
    id?: string;
    date?: string;
}

export enum DriverActionTypes {
    Default = "",
    Workflow = "Workflow",
    ConfirmHOSStatus = "ConfirmHOSStatus",
    DriverLosesVehicle = "DriverLosesVehicle",
    StorageCapacityReached = "StorageCapacityReached",
    PositionMalfunction = "PositionMalfunction",
    Login = "Login"
}

export enum LoginRequiredStatus {
    Default = "",
    LoginRequired = "LoginRequired",
    AddCoDriver = "AddCoDriver",
    Error = "Error"
}

export interface ILoginRequiredState {
    status: LoginRequiredStatus;
    errorMessage?: string;
}

export interface ILastKnownSpeed {
    speed: number;  // speed in km/h
    source: SpeedSource;
    date: Date;
}

export interface IIamUserRefreshPayload {
    key: string;
    isRefreshing: boolean;
}

export interface IIamUserSessionInvalidatedPayload {
    key: string;
    isInvalidated: boolean;
}

export enum SpeedSource {
    StatusData,
    DeviceStatusInfo,
    PhoneGps,
    Iox
}
